import { SIDEBAR_SET } from "../const";
import { ISidebarItem } from "../components/Routes";
import { MenuContainerTabs } from "../components/Routes";

export interface ISidebarState {
  position: ISidebarItem;
}

type ReduxAction = {
  type: string;
  payload?: any;
};

const INITIAL_STATE: ISidebarState = {
  position: MenuContainerTabs.DASHBOARD,
};

const reducer = (state = INITIAL_STATE, action: ReduxAction) => {
  switch (action.type) {
    case SIDEBAR_SET:
      return { ...state, position: action.payload.position };
    default:
      return state;
  }
};

export default reducer;
